module.exports = __webpack_public_path__ + "img/connect-zapier.e7404a8a.png";